import React from "react";



const Chooseplay = ({ onBack }) => {


  const sectionA = [
    {
      title: "HTSUS Classification & Raw Material Lookup",
      description:
        "Instantly assigns 10-digit US HTS codes, alternate codes, and raw-material HTS references, flagging ambiguities and re-classification risks.",
    },
    {
      title: "Multi-Assembly BOM Comparison & Compatibility Analysis",
      description:
        "Side-by-side BOM differencing: identical, substituted, or omitted parts; material and finish changes; functional compatibility call-outs.",
    },
  ];

  const sectionB = [
    {
      title: "Supplier Mix Health & Sourcing Risk",
      description:
        "Snapshot of single- vs multisourced parts, capability overlaps, and metadata gaps that threaten agility.",
    },
    {
      title: "Supplier Capability Gap & Overlap Map",
      description:
        "Visual map of materials, finishes, tolerances, and processes covered (or not) by each supplier.",
    },
    {
      title: "Sourcing Negotiation Opportunities",
      description:
        "Ranks highest-impact parts and suppliers for cost leverage; suggests bidding, consolidation, or development strategies.",
    },
    {
      title: "Cost-Per-Part Outlier & Savings Hunt",
      description:
        "Benchmarks cost/part and cost/mm against supplier/site averages; quantifies annual savings from overpriced items.",
    },
    {
      title: "Supplier-vs-Site Efficiency Matrix",
      description:
        "Heat-map of average cost/part for every Supplier × Site cell, revealing low- and high-efficiency pockets.",
    },
  ];
  const sectionC = [
    {
      title: "Complexity-to-Risk Heat-Map",
      description:
        "Blends Complexity Score, tightest tolerance, and finish count into a Manufacturing-Risk Index; highlights top high-risk parts.",
    },
    {
      title: "Tight-Tolerance Watch List",
      description:
        "User-set tolerance limit (e.g., ≤0.02 mm) drives an alert list for Cpk studies and capability audits.",
    },
    {
      title: "Special-Finish Usage Tracker",
      description:
        "Counts parts per finish, flags finishes with high demand but low supplier coverage.",
    },
  ];
  const sectionD = [
    {
      title: "Material Consolidation & Long-Tail Reduction",
      description:
        "Aggregates annual volume and mass by raw material, flags low-volume/high-supplier “long-tail” materials, and suggests substitutes.",
    },
    {
      title: "CO₂ Footprint & Sustainability Dashboard",
      description:
        "Converts material mass to CO₂-eq; lets users toggle substitutions and see potential emissions cuts.",
    },
  ];

  const renderCard = ({ title, description }) => (
    <div className="bg-white space-x-3 rounded-xl shadow p-6 w-full md:w-[550px] h-[300px] flex flex-col justify-between hover:shadow-lg transition-shadow duration-300 cursor-pointer hover:shadow-green-700">
      <h4 className="font-bold text-lg text-[#194d39] mb-2">{title}</h4>
      <p className="text-base text-gray-600 mb-4 flex-grow">{description}</p>
      <button className="bg-gray-300 text-white text-sm px-5 py-2 rounded cursor-not-allowed">
        Analyze Now
      </button>
    </div>
  );
  return (
    <div className="p-6 bg-orange-50 rounded-lg shadow-md h-full overflow-y-auto">
      <button onClick={onBack} className="text-teal-600 underline">← Back</button>
      <div className="flex justify-center items-center mb-10 gap-10">
        <div className="text-center w-52">
          <div className="bg-gray-200 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mx-auto">
            1
          </div>
          <div className="mt-2 text-gray-500">
            Select Data
          </div>
        </div>
        <div className="w-16 h-1 bg-gray-300"></div>
        <div className="text-center w-52">
          <div className="bg-lime-500 text-gray-500 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mx-auto">
            2
          </div>
          <div className=" mt-2 bg-lime-500 text-white font-bold px-2 py-1 rounded">
            Choose Play
          </div>
        </div>
        <div className="w-16 h-1 bg-gray-300"></div>
        <div className="text-center w-52">
          <div className="bg-gray-200 text-gray-500 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg mx-auto">
            3
          </div>
          <div className="mt-2 text-gray-500">
            Make Decisions
          </div>
        </div>
      </div>
      <div class="bg-green-900 text-white p-6 rounded-md w-3/4 mx-auto mb-6">
        <div className="mb-4  flex ">
          <p class="font-semibold mb-4">Questions? Book a call or send us a message:</p>
          <div class="flex  flex-1 justify-end">
            <a href="#"
              class="inline-flex items-center bg-lime-500 text-black px-4 py-2 rounded hover:bg-lime-400 transition shadow">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Book a 15-min Call
            </a>
          </div>
        </div>

        <form class="space-y-4">
          <div class="flex flex-col sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0">
            <input type="email" placeholder="Enter your email"
              class="px-3 py-2 rounded border border-gray-300 text-black w-full sm:w-1/2" />
            <input type="text" placeholder="Phone(opt)"
              class="px-3 py-2 rounded border border-gray-300 text-black w-full sm:w-1/2" />
          </div>
          <input placeholder="How can we help you?"
            class="w-full px-3 py-2 rounded border border-gray-300 text-black" ></input>

          <button type="submit"
            class="bg-lime-500 text-black px-4 py-2 rounded hover:bg-lime-400 transition">Send</button>
        </form>

        <p class="mt-4 text-sm">Or email:
          <a href="mailto:contact@sourceoptima.com" class="font-semibold underline">contact@sourceoptima.com</a>
        </p>


      </div>

      <div className="text-center my-5">
        <h1 className="text-[34px] text-[#194d39] font-bold">SourceOptima Playbook</h1>
        <h3 className="text-gray-600">Turn your CAD into decisions.</h3>
      </div>
      <br />
      <div className="gap-4 ">
        <div className="mb-10">
          <h2 className="text-lg font-semibold text-[#194d39] mb-4 pl-2 border-l-4 border-green-700">
            A. Compliance & Technical Classification
          </h2>

          <div className="flex flex-wrap gap-6">
            {sectionA.map((card, idx) => (
              <div key={idx}>{renderCard(card)}</div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-[#194d39] mb-4 pl-2 border-l-4 border-green-700">B. Supplier Intelligence & Sourcing Power</h2>
          <div className="flex flex-wrap gap-6">
            {sectionB.map((card, idx) => (
              <div key={idx}>{renderCard(card)}</div>
            ))}
          </div>
        </div>
        <br />
        <div>
          <h2 className="text-lg font-semibold text-[#194d39] mb-4 pl-2 border-l-4 border-green-700">C. Quality, Manufacturability & Risk</h2>
          <div className="flex flex-wrap gap-6">
            {sectionC.map((card, idx) => (
              <div key={idx}>{renderCard(card)}</div>
            ))}
          </div>
        </div>
        <br />
        <div>
          <h2 className="text-lg font-semibold text-[#194d39] mb-4 pl-2 border-l-4 border-green-700">D. Material Strategy & Sustainability</h2>
          <div className="flex flex-wrap gap-6">
            {sectionD.map((card, idx) => (
              <div key={idx}>{renderCard(card)}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Chooseplay;